import BlogPostPreviewCard from 'components/blog/BlogPostPreviewCard'
import TopPoster from 'components/body/TopPoster'
import GoogleTagManagerAttributes from 'components/core/GoogleTagManagerAttributes'
import SingleTextHero from 'components/hero/SingleTextHero'
import Footer from 'components/layout/Footer'
import MainMenu from 'components/layout/MainMenu'
import TopMenuBar from 'components/layout/TopMenuBar'
import AnyHeroWrapper from 'components/renderers/AnyHeroWrapper'
import HeaderContainer from 'components/renderers/HeaderContainer'
import Env from 'Env'
import { TopPosterModel } from 'models/body/TopPosterModel'
import { BlogPostModel } from 'models/core/BlogPostModel'
import { MenuModel } from 'models/menu/MenuModel'
import { GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'

type Props = {
  menu: MenuModel
  footer: MenuModel
  blogPosts: BlogPostModel['data'][]
  isPreview: boolean
  posters: {
    data: TopPosterModel[]
  }
}

const BlogIndexPage: NextPage<Props> = (props) => {
  const blogPageTitle = 'SecureMyEmail Blog'
  return (
    <Fragment>
      <Head>
        <title>{blogPageTitle}</title>
      </Head>
      <GoogleTagManagerAttributes />

      <HeaderContainer posters={props.posters} menu={props.menu} />

      <AnyHeroWrapper componentClassNames={`inner-banner md:pb-[90px] md:text-2xl pt-[50px] pb-[90px] bg-inner-banner bg-center bg-no-repeat bg-cover text-center z-10 relative text-lg text-white font-lato`}>
        <SingleTextHero data={{ title: blogPageTitle }} />
      </AnyHeroWrapper>
      <div className="container">
        <div className="blog-list md:px-7 px-4 py-12 shadow-[0_1px_18px_rgba(239,239,239,1)]">
          {props.blogPosts.map((post, index) => {
            return <BlogPostPreviewCard key={index} post={post} />
          })}
        </div>
      </div>
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const isPreview = context.preview
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const menuAndFooter = ApiPromise.Layout.GetMainAndFooterMenu()
  const [menuPromise, footerPromise, postersPromise] = await Promise.all(menuAndFooter)
  const [menu, footer, posters] = Converters.KeysConvert.ConvertAllToLower([menuPromise.data, footerPromise.data, postersPromise.data])
  const posts = await ApiPromise.Blog.Posts().then((resp) => convert(resp.data))
  const blogPosts = posts['data']

  return { props: { menu, footer, blogPosts, posters, isPreview: isPreview ? true : false }, revalidate: Env.PropsRevalidateTime }
}

export default BlogIndexPage
